import { type ReactElement, type ReactNode } from 'react';
import { Dimension, Check } from '@hungryroot/ui-kit';
import styles from './Toast.module.css';

export enum ToastVariant {
  Success,
  Critical,
  Neutral,
}

type Props = {
  testid?: string;
  variant: ToastVariant;
  children: ReactNode;
  className?: string;
} & {
  iconLeft?: ReactElement;
};

function getVariantClassName(variant: ToastVariant): string {
  switch (variant) {
    case ToastVariant.Success:
      return styles['success'];
    case ToastVariant.Critical:
      return styles['critical'];
    case ToastVariant.Neutral:
      return styles['neutral'];
  }
}

function getSuccessLeftIcon(iconVariant?: ReactElement): ReactNode {
  if (iconVariant === undefined) {
    return <Check />;
  }

  return iconVariant;
}

export function Toast(props: Props) {
  const { variant, children, iconLeft, testid, className } = props;
  const variantClassName = getVariantClassName(variant);

  return (
    <Dimension
      level="three"
      data-testid={testid}
      className={`${variantClassName} ${className}`}
    >
      {variant === ToastVariant.Success ? getSuccessLeftIcon(iconLeft) : null}
      {children}
    </Dimension>
  );
}
